module.exports = __webpack_public_path__ + "img/1.2025cc06.png";